import { createContext, useContext } from 'react';

export const DisabledContext = createContext({});

export const useDisabled = () => {
  const disabled = useContext(DisabledContext);

  return { disabled };
};
